<template>
  <div id="purchaseQuotation" style="width: 100%; height: 100%" v-loading="loading">
    <el-row>
      <el-col :span="24">
        <el-form :model="searchForm" ref="searchForm" :inline="true" @keyup.enter.native="this.queryTable">
          <el-form-item label="供应商：">
            <el-input size="medium" v-model="searchForm.supplierName" placeholder="请输入供应商名称" clearable></el-input>
          </el-form-item>
          <el-form-item label="生效日期：">
            <el-date-picker size="medium" v-model="searchForm.date" @change="timeChange" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
              type="date" placeholder="请选择日期" clearable>
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" :loading="loadSearch" v-preventReClick @click="this.queryTable" style="float: right">筛选
            </el-button>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" plain v-preventReClick style="float: right" @click="openExport">导出</el-button>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" plain v-preventReClick style="float: right" @click="toPriceComparitionResult">一键比价</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="tableData" border stripe style="width: 100%">
          <el-table-column type="index" label="序号" width="45" min-width="30"></el-table-column>
          <el-table-column prop="AB_NAME" label="供应商"></el-table-column>
          <el-table-column prop="NEXT_START_DATE" label="生效时间"></el-table-column>
          <el-table-column prop="NEXT_END_DATE" label="失效日期"></el-table-column>
          <el-table-column fixed="right" label="操作" width="150">
            <template slot-scope="scope">
              <i class="el-icon-edit-outline" style="color: #409eff"></i>
              <el-button v-preventReClick type="text" size="small" @click="add(scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount">
        </el-pagination>
      </el-col>
    </el-row>
    <!-- 导出选择公司模态框 -->
    <el-dialog title="请选择公司" center :visible.sync="exportFormVisible" width="600px" @close="close('exportForm')">
      <el-form :model="exportForm" ref="exportForm" style="margin-top: 0" size="small" :rules="rules">
        <el-form-item :label-width="formLabelWidth" prop="company">
          <label slot="label">公司名称：</label>
          <el-select filterable v-model="exportForm.company" placeholder="请选择公司" style="width: 100%">
            <el-option v-for="item in companyList" :key="item.value" :label="item.AB_NAME" :value="item.ID">
              <span style="float: left; width: 50px; text-align: center">{{
              item.AB_NAME
              }}</span>
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="close('exportForm')">取 消</el-button>
        <el-button size="small" @click="submitExport('exportForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { querySupplyChainQuote, getSupplierList, exportSupplyChainQuote } from 'api/quote';
import http from '@/assets/common/http';

export default {
  data() {
    return {
      loading: false,
      loadSearch: false,
      myWeek: '',
      formLabelWidth: '100px',
      rules: {},
      tableData: [],
      currentPage: 1,
      totalCount: 0,
      pageSize: 20,
      addForm: {
      },
      companyList: [],
      exportForm: {
        company: '',
      },
      exportFormVisible: false,
      searchForm: {
        supplierName: '',
        date: '',
      },
    };
  },
  methods: {
    toPriceComparitionResult() {
      const params = {
        SERVICE_ID: '10014',
        OTYPE: 10,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      http.post(params).then((result) => {
        this.$router.push({ path: '/priceComparitionResult' });
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    timeChange(e) {
      this.$store.dispatch('SHOPPING_DOCUMENT_TIME', {
        TIME: e,
        GROUPID: this.searchForm.groupID,
      });
    },
    queryTable() {
      this.querySupplierQuotationList(this.searchForm.supplierName, this.searchForm.date);
      if (this.tableData.length == 0) {
        this.$message.show({ text: '暂无数据', type: 'success' });
      }
    },
    add(row) {
      sessionStorage.setItem('supplierId', row.SUPPLIER_ID);
      sessionStorage.setItem('customerType', 1);
      sessionStorage.setItem('prevUrl', '/purchaseQuotation');
      this.$router.push({ name: 'viewPrice' });
    },
    queryGetTime() {
      const mydate = new Date();
      this.myWeek = mydate.getDay(); // 获取存储当前日期
    },
    async querySupplierQuotationList(supplierName = '', effectiveDate = '') {
      this.loading = !this.loading;
      this.loadSearch = !this.loadSearch;
      const params = {
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        PAGEINDEX: this.currentPage - 1,
        PAGESIZE: this.pageSize,
      };
      if (supplierName !== '') params.SUPPLIER_NAME = supplierName;
      if (effectiveDate !== '') params.EFFECTIVE_DATE = effectiveDate;
      await querySupplyChainQuote(params).then((result) => {
        if (result[0].OP_ROLE.length !== 0) {
          this.tableData = result[0].OP_ROLE;
          this.totalCount = result[0].TOTAL_COUNT;
          // tableData你的数据源
        } else {
          this.tableData = [];
          this.totalCount = 0;
          // this.$message.show({ text: '暂无数据', type: 'success' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
      this.loading = !this.loading;
      this.loadSearch = !this.loadSearch;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.defaultQuery();
    },
    close(formName) {
      this.$refs[formName].resetFields();
      const modalName = `${formName}Visible`;
      this[`${modalName}`] = false;
    },
    queryTitle() {
      getSupplierList().then((result) => {
        this.companyList = result.length > 0 ? result[0].company : [];
      })
        .catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    openExport() {
      this.exportFormVisible = true;
      this.queryTitle();
    },
    submitExport() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          if (!this.exportForm.company) {
            this.$message.show({ text: '请选择公司', type: 'warning' });
            document.body.style.cursor = 'default';
            return false;
          }
          const params = {
            SUPPLIER_ID: this.exportForm.company,
          };
          exportSupplyChainQuote(params).then((result) => {
            window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
            this.$message.show({ text: '导出成功', type: 'success' });
            this.exportFormVisible = false;
            document.body.style.cursor = 'default';
          })
            .catch((error) => {
              this.$message.show({ text: error, type: 'error' });
              document.body.style.cursor = 'default';
            });
        } finally {
          // console.log("我执行完了")
          // document.body.style.cursor="default";
        }
      }
    },
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    this.querySupplierQuotationList();
    this.queryGetTime();
  },
};
</script>




// WEBPACK FOOTER //
// src/components/priceManagement/purchaseQuotation.vue